// Components
import Text from "components/atoms/Text/Text";
import ContainerDiv from "components/atoms/ContainerDiv/ContainerDiv";

// Modules
import styles from "components/atoms/LinkItem/LinkItem.module.css";

// Type Definitions
export type LinkItemProps = {
	title?: string;
	description?: string;
	isInsideDropdown?: boolean;
};

const LinkItem = ({ title, description, isInsideDropdown = false }: LinkItemProps): JSX.Element => {
	return (
		<ContainerDiv classes={isInsideDropdown ? styles.dropdownContainer : styles.container} testid="link-item">
			<Text classes={isInsideDropdown ? styles.dropdownText : styles.headlineText} textContent={title} />
			<Text classes={isInsideDropdown ? styles.dropdownText : styles.subText} textContent={description} />
		</ContainerDiv>
	);
};

export default LinkItem;
